/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import Question from './Question';
import Notes from './Notes';

class SupplementaryContent extends Component {
  state = {
    shouldTransition: true,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const shouldTransition =
      (nextProps.chunk.get('question') === null) !==
      (this.props.chunk.get('question') === null);

    this.setState({
      shouldTransition,
    });
  }

  hasNotes = () => {
    return this.props.chunk.get('notes') || this.props.chunk.get('more_notes');
  };

  render() {
    const chunk = this.props.chunk;

    if (!chunk.get('video') && !chunk.get('youtube_url')) {
      return null;
    }

    return (
      <div id="supplementary-content">
        <ReactCSSTransitionGroup
          transitionName={this.state.shouldTransition ? 'slide' : ''}
          transitionAppear
          transitionAppearTimeout={200}
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {chunk.get('question') ? (
            <Question
              key={chunk.getIn(['question', 'id'])}
              lesson={this.props.lesson}
              question={chunk.get('question')}
              onResponseSave={this.props.onChunkComplete}
              analyticsPayload={this.props.analyticsPayload}
              lessonQuizAttempts={this.props.lessonQuizAttempts}
              saveQuizAttempt={this.props.saveQuizAttempt}
            />
          ) : null}
          {this.hasNotes() && !chunk.get('question') ? (
            <Notes chunk={chunk} />
          ) : null}
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default SupplementaryContent;
